module.exports = __webpack_public_path__ + "static/media/u24b_2.40d98812.mp3";